
import { defineComponent, inject, computed, ComputedRef } from 'vue'
import { formatTimeString } from '@/services/agenda'
import { useRouter } from 'vue-router'
import { useStore } from '@/store'

export default defineComponent({
  name: 'AgendaSessionItem',
  props: {
    sessionId: {
      type: String,
      required: true
    }
  },
  setup (props) {
    const { getSessionById } = useStore()
    const router = useRouter()
    const { xsOnly, languagePack } = useStore()
    const languageType = inject<ComputedRef<'zh' | 'en'>>('languageType') || { value: 'zh' }
    const roomsStatus = inject<ComputedRef<{ [k: string]: boolean }>>('roomsStatus') || { value: {} }
    const session = computed(() => {
      const session = getSessionById(props.sessionId)
      if (session === null) throw new Error('Invalid Session')
      return session
    })
    const location = computed(() => {
      return {
        name: 'AgendaDetail',
        params: {
          ...router.currentRoute.value.params,
          sessionId: props.sessionId
        }
      }
    })
    const track = computed(() => session.value.type[languageType.value].name)
    const period = computed(() => `${formatTimeString(session.value.start, '：')} ~ ${formatTimeString(session.value.end, '：')}`)
    const title = computed(() => session.value[languageType.value].title)
    const speakers = computed(() => session.value.speakers.map((speaker) => speaker[languageType.value].name))
    const tags = computed(() => session.value.tags.map((tag) => tag[languageType.value].name))
    const language = computed(() => session.value.language)
    const room = computed(() => session.value.room[languageType.value].name.split(' / ')[0])

    const isFull = computed(() => !!(roomsStatus.value[session.value.room.id]))
    const statusText = computed(() => languagePack.value.agenda['room-status'][isFull.value ? 'full' : 'vacancy'])

    return {
      xsOnly,
      session,
      location,
      track,
      period,
      title,
      speakers,
      tags,
      language,
      room,
      isFull,
      statusText
    }
  }
})
